<template>
  <div>
    <v-dialog name="dialog" />
    <div class="admin_title">讲师管理</div>
    <div class="gj_top_class">
      <input name="" type="button" class="btn_s_gj" @click="search(filters)"/>
      <input name="" type="text" class="put_gj" v-model="filters.name" @keyup.13="search(filters)" />
      <a @click="to('teacher', 'void')">新增讲师</a>
    </div>
    <div class="teacher_list" style="min-height: 600px;">
      <!--暂无讲师提示-->
      <h5 class="none_ts" v-if="cntData <= 0 || !lists">
        <img src="@/assets/images/none_data.jpg" alt="">
      </h5>
      <!--暂无讲师提示-->
      <!--讲师列表-->
      <dl v-for="item in lists" :key="item.id">
        <dt>
          <img src="@/assets/images/teacher-avatar.png" v-if="!item.faceUrl || item.faceUrl == ''" />
          <img :src="item.faceUrl" v-if="item.faceUrl && item.faceUrl !== ''">
        <p><a @click="to('teacher', item.id)">编辑</a>　|　<a @click="del(item.id)">删除</a></p>
        </dt>
        <dd>{{item.name}}</dd>
      </dl>
      <!--/讲师列表-->
    </div>
    <div class="zy_list_bottom mtf30">
      <dl>
        <dt v-if="cntData > 0"><!--<input id="sel_1" onchange="selectAll()" type="checkbox" value="1" style="opacity: 1;"/> 全选 <input name="" type="button" value="批量上架" class="btn_zy_bottom" /> <input name="" type="button" value="批量下架"  class="btn_zy_bottom"/> <input name="" type="button" value="删除所选"  class="btn_zy_bottom" />-->共{{cntData}}个讲师</dt>
        <dd v-if="cntData > 0">
          <paginate :click-handler="clickCallback" :page-count=pages
                    :container-class=$global.paginationOptions.container_class :page-class=$global.paginationOptions.page_class :page-link-class=$global.paginationOptions.page_link_class
                    :prev-class=$global.paginationOptions.prev_class :prev-link-class=$global.paginationOptions.prev_link_class
                    :next-class=$global.paginationOptions.next_class :next-link-class=$global.paginationOptions.next_link_class
                    :first-last-button=$global.paginationOptions.first_last_button
                    :active-class=$global.paginationOptions.active_class
                    :disabled-class=$global.paginationOptions.disabled_class
                    :first-button-text=$global.paginationOptions.first_button_text
                    :last-button-text=$global.paginationOptions.last_button_text
                    :prev-text=$global.paginationOptions.prev_text
                    :next-text=$global.paginationOptions.next_text>
          </paginate>
        </dd>
      </dl>
    </div>
    <div class="clear"></div>
  </div>
</template>
<script>
import config from '@/config'
import api from '@/api'
import utils from '@/utils'
import Paginate from 'vuejs-paginate'
export default {
  components: { Paginate },
  data () {
    return {
      lists: [],
      filters: {
        pageNo: 1,
        pageSize: 12,
        name: '',
        delFlag: '0'
      },
      cntData: '',
      pages: 0
    }
  },
  mounted () {
    this.search(this.filters) //  默认无搜索条件获取列表
  },
  methods: {
    clickCallback (pageNum) {
      this.filters.pageNo = pageNum
      this.search(this.filters)
    },
    to (path, id) {
      this.$router.push({
        path: path + '/' + id
      })
    },
    confirmBox (o) {
      var that = this
      this.$modal.show('dialog', {
        title: o.title,
        text: o.text,
        buttons: [
          {
            title: '确认',
            default: true,
            handler: utils.debounce(() => {
              if (o.yes && o.yes instanceof Function) {
                o.yes()
                that.$modal.hide('dialog') // !!!必须清掉模态框，否则在别的页面按enter键会触发方法的
              }
            }, 1000)
          },
          {
            title: '取消'
          }
        ]
      })
    },
    del (id) {
      if (id) {
        var that = this
        this.confirmBox({
          title: '删除',
          text: '确认删除吗?',
          yes: function () {
            api.get(config.teacherApiPath, '/teacher/delete/' + id, null, r => {
              that.$toasted.show('删除成功')
              that.search(that.filters)
              that.$modal.hide('dialog')
            })
          }
        })
      }
    },
    search (filters) {
      if (!filters) { filters = {} }
      var that = this
      api.post(config.teacherApiPath, '/teacher/teachers', filters, function (r) {
        that.lists = r.data
        that.cntData = r.cntData
        that.pages = Math.ceil(r.cntData / that.filters.pageSize)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/page/byl/org/teacher/list.vue